import { render, staticRenderFns } from "./Top4BeautyOEM.vue?vue&type=template&id=770f6f9a&scoped=true"
import script from "./Top4BeautyOEM.vue?vue&type=script&lang=js"
export * from "./Top4BeautyOEM.vue?vue&type=script&lang=js"
import style0 from "./Top4BeautyOEM.vue?vue&type=style&index=0&id=770f6f9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770f6f9a",
  null
  
)

export default component.exports